<template>
  <div class="basic-list -mt">
    <h3 class="section-title">Categorized messages:</h3>
    <ul>
      <li v-if="categorizedMessages.length === 0">
        No categorized messages yet. <router-link to="/training">Start training</router-link>
      </li>
      <li v-for="message in categorizedMessages" :key="message.id" :class="{ '-highlight': message.changed }">
        <input v-model="message.message" type="text" @keydown="message.changed = true" />
        <a v-show="message.changed" href="#" class="update-btn" @click.prevent="updateMessage(message)"></a>
        <a href="#" class="remove-btn" @click.prevent="remove(message)"></a>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'categorized_messages';

export default {
  props: {
    messages: {
      type: Array,
      required: true
    },
    categoryId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      categorizedMessages: []
    };
  },

  watch: {
    messages() {
      this.categorizedMessages = this.messages;
    }
  },

  methods: {
    remove(message) {
      const params = { messageId: message.id, categoryId: this.categoryId };
      this.$store.dispatch("deleteCategorizedMessage", params);
    },

    updateMessage(message) {
      const params = {
        team_id: auth.teamId(),
        category_ids: [this.categoryId],
        message: message.message
      };

      api
        .instance()
        .put(`/${apiVersion}/${source}/${message.id}`, params)
        .then((resp) => {
          this.categorizedMessages = _.map(this.categorizedMessages, (msg) => {
            if (msg.id === message.id) msg.changed = false;
            return msg;
          });
        })
        .catch((err) => {
          console.error("Error updating categorized message:", err);
        });
    }
  }
};
</script>
